const ruby = {
  50: "#ffe7ef",
  100: "#f9c4d7",
  200: "#ef8eb1",
  300: "#e55589",
  400: "#dd2567",
  500: "#d6004d",
  600: "#c50047",
  700: "#ad003e",
  800: "#930035",
  900: "#82002f",
  A100: "#ff679a",
  A200: "#ff3177",
  A400: "#f50057",
  A700: "#c50046",
};

export default ruby;
